import {graphql} from 'gatsby'
import React from 'react'
import styled from 'styled-components'

import Button from '@/components/button'
import type {Props as PrismicLinkProps} from '@/components/prismic-link'
import PrismicLink from '@/components/prismic-link'
import type {Props as RichTextProps} from '@/components/rich-text'
import RichText from '@/components/rich-text'
import {Text} from '@/components/text'
import {Layout, Section} from '@/styles/grid'
import mq from '@/utils/media-query'

export interface Props {
    title: string
    copy: RichTextProps['content']
    ctaLabel?: string
    ctaLink?: PrismicLinkProps
}

export const TitleWithSideText = ({title, ctaLabel, ctaLink, copy}: Props) => {
    return (
        <Layout as={Section} $variant="two-asymmetrical">
            <TitleBodyWrapper>
                <Text $variant="heading-base" as="h2">
                    {title}
                </Text>
                {ctaLabel && ctaLink && (
                    <ButtonDesktop $variant="outline" forwardedAs={PrismicLink} {...ctaLink}>
                        {ctaLabel}
                    </ButtonDesktop>
                )}
            </TitleBodyWrapper>
            <RichText content={copy} />

            {ctaLabel && ctaLink && (
                <ButtonMobile $variant="outline" forwardedAs={PrismicLink} {...ctaLink}>
                    {ctaLabel}
                </ButtonMobile>
            )}
        </Layout>
    )
}

export const TitleBodyWrapper = styled.div`
    display: grid;
    justify-items: start;
    gap: ${({theme}) => theme.spacings.s20};

    ${mq.min('sm')} {
        gap: ${({theme}) => theme.spacings.s28};
    }
`

const ButtonMobile = styled(Button)`
    ${mq.min('sm')} {
        display: none;
    }
`

const ButtonDesktop = styled(Button)`
    ${mq.max('sm')} {
        display: none;
    }
`

export const titleWithSideTextFragment = graphql`
    fragment TitleWithSideText on PrismicSlicePageDataBodyTitleWithSideText {
        __typename
        primary {
            title
            copy {
                richText
            }
            cta_label
            cta_link {
                ...PrismicLink
            }
        }
    }
`
